const Contact = () => {
    return (
        <div className="page">
            <h1>Contact</h1>
        </div>
    );
}

export default Contact;